module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-600.95787823.ttf";